<template lang="pug">
div
  el-row(
    v-if="tipoCadastro==='PERMUTA'"
  )
    el-col(:span="24")
      app-display(
        label="Pertence ao Projeto Integrado Trairão?",
        :content="qualificacao.pertenceAoProjeto ? 'Sim, ' + qualificacao.gleba.nome : 'Não'",
      )
      app-display(
        label="O interessado é o beneficiário original?",
        :content="qualificacao.beneficiarioOriginal ? 'Sim' : 'Não'",
      )
      app-display(
        label="O Valor da Terra Nua (VTN) foi pago integralmente?",
        :content="qualificacao.beneficiarioOriginal ? 'Sim' : 'Não'",
      )

  el-row(
    v-else-if="tipoCadastro!=='CERTIDAO_TITULO' && tipoCadastro!=='ONEROSO'"
  )
    el-col(:span="24")
      app-display(
        label="Qual o tamanho da área deste beneficiário?",
        :content="qualificacao.area",
      )
      app-display(
        label="Qual a renda familiar?",
        :content="qualificacao.nomeRenda",
      )
      app-display(
        label="Este beneficiário e/ou seu cônjuge exerce cargo ou função pública em órgão fundiário?",
        :content="qualificacao.cargoPublico ? 'Sim' : 'Não'",
      )
      app-display(
        label="Este beneficiário e/ou seu cônjuge possui outro imóvel rural titulado?",
        :content="qualificacao.possuiImovelRuralTitulado ? 'Sim' : 'Não'",
      )
      app-display(
        label="Ocupa e explora diretamente o imóvel de forma mansa e pacífica, por si ou por seus antecessores? ",
        :content="qualificacao.ocupaImovel ? 'Sim' : 'Não'",
      )
      app-display(
        label="A principal atividade exercida por este beneficiário é a exploração agrícola do imóvel?",
        :content="qualificacao.exploracaoAgricola ? 'Sim' : 'Não'",
      )
      app-display(
        label="Situação: ",
        :content="getSituacao",
        v-if="tipoCadastro==='PEAS'"
      )

  el-row(v-if="tipoCadastro==='CERTIDAO_TITULO'")
    el-col(:span="24")
      app-display(
        label="É beneficiário originário?",
        :content="qualificacao.beneficiarioOriginario ? 'Sim' : 'Não'",
      )
      app-display(
        label="A área é georreferenciada tendo sido o Título emitido de acordo com a Lei 10.267/01? ",
        :content="qualificacao.areaGeorreferenciada ? 'Sim' : 'Não'",
      )
      app-display(
        label="A área está matriculada?",
        :content="qualificacao.areaMatriculada ? 'Sim' : 'Não'",
      )

  el-row(v-else-if="tipoCadastro==='ONEROSO'")
    el-col(:span="24")
      app-display(
        label="Você e/ou seu cônjuge exerce cargo ou função pública em órgão fundiário?",
        :content="qualificacao.cargoPublico ? 'Sim' : 'Não'"
      )
      app-display(
        label="Você e/ou seu cônjuge possui outro imóvel rural titulado por doação?",
        :content="qualificacao.possuiImovelRuralTitulado ? 'Sim' : 'Não'"
      )
      app-display(
        label="Ocupa e explora diretamente o imóvel de forma mansa e pacífica, por si ou por seus antecessores há no mínimo 5 (cinco) anos?",
        :content="qualificacao.ocupaImovel ? 'Sim' : 'Não'"
      )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'

export default {

  components: {
    AppDisplay
  },

  props: {
    qualificacao: {
      type: Object,
      required: true
    },
    tipoCadastro: {
      type: String
    }
  },

  computed: {
    getSituacao () {
      if ((Number(this.qualificacao.area)) <= 100 &&
        this.qualificacao.renda !== 'mais5' &&
        !this.qualificacao.cargoPublico &&
        !this.qualificacao.possuiImovelRuralTitulado &&
        this.qualificacao.ocupaImovel &&
        this.qualificacao.exploracaoAgricola) {
        return 'Apto'
      }
      return 'Não Apto'
    }
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppQualificacao.vue